<ng-container *ngIf="isShow">
  <div class="l-section u-mt-sp-32 u-mt-tb-40 u-mt-pc-56">
    <div class="p-heading-area01">
      <div class="p-heading-area01__title">
        <h2 class="p-heading-area01__title c-heading-2" [innerHTML]="'label.optionalServices' | staticMsg"></h2>
      </div>
    </div>

    <div class="p-manage-booking">
      <div class="services-wrapper">
        <!-- ▼ ▼ ▼ 事前追加手荷物(未申込) ▼ ▼ ▼ -->
        <ng-container *ngIf="serviceDisplayState.fBag.isShowBtn">
          <asw-unapplied-svc-apply-btn
            [isPlanValid]="isPlanValid"
            [serviceType]="'fBag'"
            [minPrice]="baggageMin"
            [currencyCode]="currencyCode"
          ></asw-unapplied-svc-apply-btn>
        </ng-container>

        <!-- ▼ ▼ ▼ 事前追加手荷物(申込済) ▼ ▼ ▼ -->
        <ng-container *ngIf="serviceDisplayState.fBag.isShowTable">
          <asw-plan-review-fbag
            [isPlanValid]="isPlanValid"
            [data]="outputFBagInfo"
            [currencyCode]="currencyCode"
          ></asw-plan-review-fbag>
        </ng-container>

        <!-- ▼ ▼ ▼ ラウンジ(未申込) ▼ ▼ ▼ -->
        <ng-container *ngIf="serviceDisplayState.lounge.isShowBtn">
          <asw-unapplied-svc-apply-btn
            [isPlanValid]="isPlanValid"
            [serviceType]="'loug'"
            [minPrice]="loungeMin"
            [currencyCode]="currencyCode"
          ></asw-unapplied-svc-apply-btn>
        </ng-container>

        <!-- ▼ ▼ ▼ ラウンジ(申込済) ▼ ▼ ▼ -->
        <ng-container *ngIf="serviceDisplayState.lounge.isShowTable">
          <asw-plan-review-lounge
            [isPlanValid]="isPlanValid"
            [data]="outputLoungeInfo"
            [currencyCode]="currencyCode"
          ></asw-plan-review-lounge>
        </ng-container>

        <!-- ▼ ▼ ▼ 機内食(未申込) ▼ ▼ ▼ -->
        <ng-container *ngIf="serviceDisplayState.meal.isShowBtn">
          <asw-unapplied-svc-apply-btn [isPlanValid]="isPlanValid" [serviceType]="'meal'"></asw-unapplied-svc-apply-btn>
        </ng-container>

        <!-- ▼ ▼ ▼ 機内食(申込済) ▼ ▼ ▼ -->
        <ng-container *ngIf="serviceDisplayState.meal.isShowTable">
          <asw-plan-review-meal
            [isPlanValid]="isPlanValid"
            [data]="outputMealInfo"
            [currencyCode]="currencyCode"
            [mealApplicationState]="mealApplicationState"
          ></asw-plan-review-meal>
        </ng-container>

        <!-- ▼ ▼ ▼ FY25: ペットらくのり(未申込) ▼ ▼ ▼ -->
        <ng-container *ngIf="serviceDisplayState.pet.isShowBtn">
          <asw-unapplied-svc-apply-btn [isPlanValid]="isPlanValid" [serviceType]="'pet'"></asw-unapplied-svc-apply-btn>
        </ng-container>

        <!-- ▼ ▼ ▼ FY25: ペットらくのり(申込済) ▼ ▼ ▼ -->
        <ng-container *ngIf="serviceDisplayState.pet.isShowTable">
          <asw-plan-review-pet [isPlanValid]="isPlanValid" [data]="outputPetInfo"></asw-plan-review-pet>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
